import * as React from 'react';
import { twMerge } from 'tailwind-merge';
import { onEnter } from '../../util/KeyPressHandlers';
var Tab = function (props) {
    var active = props.active, tabLabel = props.tabLabel, onClick = props.onClick;
    return (React.createElement("div", { className: twMerge('flex cursor-pointer list-none flex-col items-center px-8 pb-4 text-common-dark-gray focus:outline-none mobile:text-[12px]', active && 'border-0 border-b-2 border-solid border-primary text-black outline-none'), role: "tab", tabIndex: 0, onKeyPress: onEnter(function () { return onClick(tabLabel); }), onClick: function () { return onClick(tabLabel); } },
        React.createElement("p", { className: "text-[18px] font-semibold" }, tabLabel)));
};
export default Tab;
